const localisation__countryNames = { "Afghanistan": "AF", "Aland Islands": "AX", "Albania": "AL", "Algeria": "DZ", "Andorra": "AD", "Angola": "AO", "Anguilla": "AI", "Antigua And Barbuda": "AG", "Argentina": "AR", "Armenia": "AM", "Aruba": "AW", "Ascension Island": "AC", "Australia": "AU", "Austria": "AT", "Azerbaijan": "AZ", "Bahamas": "BS", "Bahrain": "BH", "Bangladesh": "BD", "Barbados": "BB", "Belarus": "BY", "Belgium": "BE", "Belize": "BZ", "Benin": "BJ", "Bermuda": "BM", "Bhutan": "BT", "Bolivia": "BO", "Bosnia And Herzegovina": "BA", "Botswana": "BW", "Brazil": "BR", "British Indian Ocean Territory": "IO", "Virgin Islands, British": "VG", "Brunei": "BN", "Bulgaria": "BG", "Burkina Faso": "BF", "Burundi": "BI", "Cambodia": "KH", "Republic of Cameroon": "CM", "Canada": "CA", "Cape Verde": "CV", "Caribbean Netherlands": "BQ", "Cayman Islands": "KY", "Central African Republic": "CF", "Chad": "TD", "Chile": "CL", "China": "CN", "Christmas Island": "CX", "Cocos (Keeling) Islands": "CC", "Colombia": "CO", "Comoros": "KM", "Congo": "CG", "Congo, The Democratic Republic Of The": "CD", "Cook Islands": "CK", "Costa Rica": "CR", "Croatia": "HR", "Curaçao": "CW", "Cyprus": "CY", "Czech Republic": "CZ", "Côte d'Ivoire": "CI", "Denmark": "DK", "Djibouti": "DJ", "Dominica": "DM", "Dominican Republic": "DO", "Ecuador": "EC", "Egypt": "EG", "El Salvador": "SV", "Equatorial Guinea": "GQ", "Eritrea": "ER", "Estonia": "EE", "Eswatini": "SZ", "Ethiopia": "ET", "Falkland Islands (Malvinas)": "FK", "Faroe Islands": "FO", "Fiji": "FJ", "Finland": "FI", "France": "FR", "French Guiana": "GF", "French Polynesia": "PF", "French Southern Territories": "TF", "Gabon": "GA", "Gambia": "GM", "Georgia": "GE", "Germany": "DE", "Ghana": "GH", "Gibraltar": "GI", "Greece": "GR", "Greenland": "GL", "Grenada": "GD", "Guadeloupe": "GP", "Guatemala": "GT", "Guernsey": "GG", "Guinea": "GN", "Guinea Bissau": "GW", "Guyana": "GY", "Haiti": "HT", "Honduras": "HN", "Hong Kong": "HK", "Hungary": "HU", "Iceland": "IS", "India": "IN", "Indonesia": "ID", "Iraq": "IQ", "Ireland": "IE", "Isle Of Man": "IM", "Israel": "IL", "Italy": "IT", "Jamaica": "JM", "Japan": "JP", "Jersey": "JE", "Jordan": "JO", "Kazakhstan": "KZ", "Kenya": "KE", "Kiribati": "KI", "Kosovo": "XK", "Kuwait": "KW", "Kyrgyzstan": "KG", "Lao People's Democratic Republic": "LA", "Latvia": "LV", "Lebanon": "LB", "Lesotho": "LS", "Liberia": "LR", "Libyan Arab Jamahiriya": "LY", "Liechtenstein": "LI", "Lithuania": "LT", "Luxembourg": "LU", "Macao": "MO", "Madagascar": "MG", "Malawi": "MW", "Malaysia": "MY", "Maldives": "MV", "Mali": "ML", "Malta": "MT", "Martinique": "MQ", "Mauritania": "MR", "Mauritius": "MU", "Mayotte": "YT", "Mexico": "MX", "Moldova, Republic of": "MD", "Monaco": "MC", "Mongolia": "MN", "Montenegro": "ME", "Montserrat": "MS", "Morocco": "MA", "Mozambique": "MZ", "Myanmar": "MM", "Namibia": "NA", "Nauru": "NR", "Nepal": "NP", "Netherlands": "NL", "New Caledonia": "NC", "New Zealand": "NZ", "Nicaragua": "NI", "Niger": "NE", "Nigeria": "NG", "Niue": "NU", "Norfolk Island": "NF", "North Macedonia": "MK", "Norway": "NO", "Oman": "OM", "Pakistan": "PK", "Palestinian Territory, Occupied": "PS", "Panama": "PA", "Papua New Guinea": "PG", "Paraguay": "PY", "Peru": "PE", "Philippines": "PH", "Pitcairn": "PN", "Poland": "PL", "Portugal": "PT", "Qatar": "QA", "Reunion": "RE", "Romania": "RO", "Russia": "RU", "Rwanda": "RW", "Samoa": "WS", "San Marino": "SM", "Sao Tome And Principe": "ST", "Saudi Arabia": "SA", "Senegal": "SN", "Serbia": "RS", "Seychelles": "SC", "Sierra Leone": "SL", "Singapore": "SG", "Sint Maarten": "SX", "Slovakia": "SK", "Slovenia": "SI", "Solomon Islands": "SB", "Somalia": "SO", "South Africa": "ZA", "South Georgia And The South Sandwich Islands": "GS", "South Korea": "KR", "South Sudan": "SS", "Spain": "ES", "Sri Lanka": "LK", "Saint Barthélemy": "BL", "Saint Helena": "SH", "Saint Kitts And Nevis": "KN", "Saint Lucia": "LC", "Saint Martin": "MF", "Saint Pierre And Miquelon": "PM", "St. Vincent": "VC", "Sudan": "SD", "Suriname": "SR", "Svalbard And Jan Mayen": "SJ", "Sweden": "SE", "Switzerland": "CH", "Taiwan": "TW", "Tajikistan": "TJ", "Tanzania, United Republic Of": "TZ", "Thailand": "TH", "Timor Leste": "TL", "Togo": "TG", "Tokelau": "TK", "Tonga": "TO", "Trinidad and Tobago": "TT", "Tristan da Cunha": "TA", "Tunisia": "TN", "Turkey": "TR", "Turkmenistan": "TM", "Turks and Caicos Islands": "TC", "Tuvalu": "TV", "United States Minor Outlying Islands": "UM", "Uganda": "UG", "Ukraine": "UA", "United Arab Emirates": "AE", "United Kingdom": "GB", "United States": "US", "Uruguay": "UY", "Uzbekistan": "UZ", "Vanuatu": "VU", "Holy See (Vatican City State)": "VA", "Venezuela": "VE", "Vietnam": "VN", "Wallis And Futuna": "WF", "Western Sahara": "EH", "Yemen": "YE", "Zambia": "ZM", "Zimbabwe": "ZW" };
const localisation__countryCodes = { "AF": "Afghanistan", "AX": "Aland Islands", "AL": "Albania", "DZ": "Algeria", "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AG": "Antigua And Barbuda", "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AC": "Ascension Island", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia", "BA": "Bosnia And Herzegovina", "BW": "Botswana", "BR": "Brazil", "IO": "British Indian Ocean Territory", "VG": "Virgin Islands, British", "BN": "Brunei", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambodia", "CM": "Republic of Cameroon", "CA": "Canada", "CV": "Cape Verde", "BQ": "Caribbean Netherlands", "KY": "Cayman Islands", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile", "CN": "China", "CX": "Christmas Island", "CC": "Cocos (Keeling) Islands", "CO": "Colombia", "KM": "Comoros", "CG": "Congo", "CD": "Congo, The Democratic Republic Of The", "CK": "Cook Islands", "CR": "Costa Rica", "HR": "Croatia", "CW": "Curaçao", "CY": "Cyprus", "CZ": "Czech Republic", "CI": "Côte d'Ivoire", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic", "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia", "SZ": "Eswatini", "ET": "Ethiopia", "FK": "Falkland Islands (Malvinas)", "FO": "Faroe Islands", "FJ": "Fiji", "FI": "Finland", "FR": "France", "GF": "French Guiana", "PF": "French Polynesia", "TF": "French Southern Territories", "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany", "GH": "Ghana", "GI": "Gibraltar", "GR": "Greece", "GL": "Greenland", "GD": "Grenada", "GP": "Guadeloupe", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea", "GW": "Guinea Bissau", "GY": "Guyana", "HT": "Haiti", "HN": "Honduras", "HK": "Hong Kong", "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IQ": "Iraq", "IE": "Ireland", "IM": "Isle Of Man", "IL": "Israel", "IT": "Italy", "JM": "Jamaica", "JP": "Japan", "JE": "Jersey", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "XK": "Kosovo", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Lao People's Democratic Republic", "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libyan Arab Jamahiriya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macao", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MQ": "Martinique", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "MD": "Moldova, Republic of", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MS": "Montserrat", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NC": "New Caledonia", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NU": "Niue", "NF": "Norfolk Island", "MK": "North Macedonia", "NO": "Norway", "OM": "Oman", "PK": "Pakistan", "PS": "Palestinian Territory, Occupied", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines", "PN": "Pitcairn", "PL": "Poland", "PT": "Portugal", "QA": "Qatar", "RE": "Reunion", "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tome And Principe", "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SX": "Sint Maarten", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa", "GS": "South Georgia And The South Sandwich Islands", "KR": "South Korea", "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "BL": "Saint Barthélemy", "SH": "Saint Helena", "KN": "Saint Kitts And Nevis", "LC": "Saint Lucia", "MF": "Saint Martin", "PM": "Saint Pierre And Miquelon", "VC": "St. Vincent", "SD": "Sudan", "SR": "Suriname", "SJ": "Svalbard And Jan Mayen", "SE": "Sweden", "CH": "Switzerland", "TW": "Taiwan", "TJ": "Tajikistan", "TZ": "Tanzania, United Republic Of", "TH": "Thailand", "TL": "Timor Leste", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad and Tobago", "TA": "Tristan da Cunha", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TC": "Turks and Caicos Islands", "TV": "Tuvalu", "UM": "United States Minor Outlying Islands", "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "US": "United States", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VA": "Holy See (Vatican City State)", "VE": "Venezuela", "VN": "Vietnam", "WF": "Wallis And Futuna", "EH": "Western Sahara", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe" };
const localisation__countryTax = { "GB": 0.2, "AU": 0.1 };
const localisation__currencies = ["GBP","USD","EUR","CAD","AUD","HKD","JPY","NZD","NOK","TWD"];
const localisation__symbols = { USD: '$', EUR: '€', GBP: '£', CAD: '$', ARS: '$', AUD: '$', BBD: 'Bds$', BDT: '৳', BSD: '$', BHD: '.د.ب', BRL: 'R$', BOB: 'Bs.', BND: 'B$', BGN: 'лв.', ILS: '₪', MMK: 'K', KYD: '$', CLP: '$', CNY: '¥', COP: '$', CRC: '₡', HRK: 'kn', CZK: 'Kč', DKK: 'kr.', DOP: 'RD$', XCD: '$', EGP: '£', XPF: 'F', FJD: '$', GHS: 'GH₵', GTQ: 'Q', GYD: '$', GEL: '₾', HKD: 'HK$', HUF: 'Ft', ISK: 'kr', INR: '₹', IDR: 'Rp', JMD: 'J$', JPY: '¥', JOD: 'د.ا', KZT: '₸', KES: 'KSh', KWD: 'د.ك', MXN: '$', MYR: 'RM', MUR: '₨', MDL: 'L', MAD: 'د.م.', MNT: '₮', MZN: 'MT', ANG: 'ƒ', NZD: '$', NGN: '₦', NOK: 'kr', OMR: '﷼', PKR: '₨', PYG: '₲', PEN: 'S/', PHP: '₱', PLN: 'zł', QAR: '﷼', RON: 'lei', RUB: '₽', SAR: '﷼', RSD: 'Дин.', SCR: '₨', SGD: '$', SYP: '£', ZAR: 'R', KRW: '₩', LKR: '₨', SEK: 'kr', CHF: 'Fr', TWD: 'NT$', THB: '฿', TZS: 'Sh', TTD: 'TT$', TRY: '₺', UAH: '₴', AED: 'د.إ', UYU: '$U', VND: '₫' };
const localisation__taxName = { "GB": "VAT", "AU": "GST" };

//update localisation with current values
const localisationCountry__select = document.getElementById("localisation-country");
const localisationCurrency__select = document.getElementById("localisation-currency");

var localisationCountry__query;
// check country & tax rates

var localisationStorage = { country: "GB", currency: "GBP", taxRate: 0.2, taxShown: true, taxEnabled: true };

// if query country is set and valid
if ((localisationCountry__query = getUrlParameter("country").toUpperCase()) && Object.values(localisation__countryNames).includes(localisationCountry__query.toUpperCase())) {
	localisationStorage.country = localisationCountry__query;
	// if query country is in taxable list
	if (Object.keys(localisation__countryTax).includes(localisationCountry__query)) {
		localisationStorage.taxRate = localisation__countryTax[localisationCountry__query];
		// if query tax is set and false
		if ((localisationTax__query = getUrlParameter("tax").toLowerCase()) && localisationTax__query == "false") {
			localisationStorage.taxShown = false;
			// else default to tax true
		} else {
			localisationStorage.taxShown = true;
		}
		// else not in list disable taxtoggle and tax and set rate to 0
	} else {
		localisationStorage.taxRate = 0;
	}
	//else query country is unset or invalid
} else {
	// if session country is set and valid
	if (('localisation-country' in sessionStorage) && (localisationCountry__session = sessionStorage.getItem('localisation-country').toUpperCase()) && Object.values(localisation__countryNames).includes(localisationCountry__session.toUpperCase())) {
		localisationStorage.country = localisationCountry__session;
		// if session country is in taxable list
		if (Object.keys(localisation__countryTax).includes(localisationCountry__session)) {
			localisationStorage.taxRate = localisation__countryTax[localisationCountry__session];

			// if session tax is set and false
			if (('localisation-tax-shown' in sessionStorage) && !(localisationTaxEnabled__session = (sessionStorage.getItem('localisation-tax-shown') == "true"))) {
				localisationStorage.taxShown = false;
				// else default to tax true
			} else {
				localisationStorage.taxShown = true;
			}
		} else {
			localisationStorage.taxRate = 0;
		}
	}
}

//currency checks
if ((localisationCurrency__query = getUrlParameter("currency").toUpperCase()) && localisation__currencies.includes(localisationCurrency__query.toUpperCase())) {
	localisationStorage.currency = localisationCurrency__query;
} else {
	if (('localisation-currency' in sessionStorage) && (localisationCurrency__session = sessionStorage.getItem('localisation-currency').toUpperCase()) && localisation__currencies.includes(localisationCurrency__session.toUpperCase())) {
		localisationStorage.currency = localisationCurrency__session;
	}
}


localisationStorage.taxEnabled = Object.keys(localisation__countryTax).includes(localisationStorage.country);

sessionStorage.setItem('localisation-currency', localisationStorage.currency);
sessionStorage.setItem('localisation-tax-shown', localisationStorage.taxShown);
sessionStorage.setItem('localisation-country', localisationStorage.country);


/*
function priceFormatter(price, currency) {
	const currency_symbol = localisation__symbols[currency];
	return currency_symbol + (Currency.convert(price, "GBP", currency) * 0.01).toFixed(2);
}
*/
const currency_symbol = localisation__symbols[localisationStorage.currency];
const taxMultiplier = (localisationStorage.taxEnabled && localisationStorage.taxShown) ? 1 + localisationStorage.taxRate : 1;

function toggleCountrySlidedown() {
	document.querySelector('.js-localisation-slidedown').classList.toggle('js-header-slidedown--open');
}
function initalPriceFormatter(price) {
	return currency_symbol + (Currency.convert(price, "GBP", localisationStorage.currency) * 0.01).toFixed(2);
}

function numberWithCommas(number) {
	var parts = number.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return parts.join(".");
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function change_Localisation(event) {
	licon.country = localisation__countryNames[lcountry.value];
	licon.currency = lcurrency.value;
	if (typeof window.shippingCalc === "function") {
		setShippingCountrySelect();
	}
}

var lcurrency = document.getElementById("localisation-currency");
var lcountry = document.getElementById("localisation-country");
var licon = document.querySelector("localisation-icon");

class PriceSpan extends HTMLElement {

	static get observedAttributes() { return ['data-price-ex', 'data-taxable', 'data-partial-tax']; }

	constructor() {
		super();
		window.customElements.whenDefined('localisation-icon').then(() => {
			this.priceFormatter();
		});
	}

	connectedCallback() {
		this.innerText = this.priceFormatter(this.priceEx * (1 + (this.taxed ? taxMultiplier : 0)));
	}

	attributeChangedCallback(name, oldValue, newValue) {
		this.dispatchEvent(new Event('change'));
		if (this.priceEx !== null && this.taxed !== null) {
			this.priceUpdater();
		}
	}

	priceUpdater() {
		this.innerText = this.priceFormatter();
	}

	priceFormatter() {
		var currency_symbol = localisation__symbols[licon.currency];
		var taxMultiplier = (licon.taxEnabled && licon.taxShown && this.taxed) ? licon.taxRate : 0;
		var value = (this.priceEx * 1) + ((this.partialTax ?? this.priceEx) * taxMultiplier);
		var formattedValue = numberWithCommas((Currency.convert(value, "GBP", licon.currency) * 0.01).toFixed(2));
		//console.log(currency_symbol,taxMultiplier,value);
		return currency_symbol + formattedValue;
	}

	set priceEx(newValue) {
		this.setAttribute('data-price-ex', newValue);
	}
	get priceEx() { return this.getAttribute('data-price-ex'); }
	set taxed(newValue) {
		if (newValue === true) {
			this.setAttribute('data-taxable', 'true');
		} else {
			this.setAttribute('data-taxable', 'false');
		}
	}
	get taxed() { return this.getAttribute('data-taxable') == 'true'; }

	get partialTax() {
		return this.getAttribute('data-partial-tax');
	}
}

customElements.define('price-span', PriceSpan);

class LocalisationIcon extends HTMLElement {

	static get observedAttributes() { return ['country', 'currency', 'tax-enabled', 'tax-shown']; }

	constructor() {
		super();
	}

	connectedCallback() {
		this.innerHTML = "<span class='localisation__country-icon'></span><span class='localisation__currency-icon'><svg xmlns='http://www.w3.org/2000/svg' xmlns:bx='https://boxy-svg.com' viewBox='0 0 26 27' width='26' height='27' fill='rgb(var(--color-foreground))'><path d='M 1 23 H 0 V 16 H 7 V 17 L 1.7071 17 C 4.131 20.335 6 25 13 25 C 20 25 25 18 25 13 H 26 C 26 19 20 26 13 26 C 6 26 3.359 21.387 1 17.7071 Z M 0 12 C 0 6 6 0 13 0 C 19 0 21.677 3.139 25 7.2929 L 25 3 H 26 V 9 H 20 V 8 L 24.2929 8 C 21.186 4.403 19 1 13 1 C 6 1 1 7 1 12 H 0 Z'/></svg></span><span class='localisation__tax-icon'></span>";

		this.countrySpan = this.querySelector(".localisation__country-icon");
		this.currencySpan = this.querySelector(".localisation__currency-icon");
		this.taxSpan = this.querySelector(".localisation__tax-icon");

		this.taxShown = localisationStorage.taxShown;
		this.taxEnabled = Object.keys(localisation__countryTax).includes(localisationStorage.country);
		this.country = localisationStorage.country;
		this.currency = localisationStorage.currency;


		this.querySelectorAll(".localisation__currency-icon").forEach(function (element) {
			element.addEventListener('click', toggleCountrySlidedown);
		}, this);

		this.querySelectorAll(".localisation__country-icon").forEach(function (element) {
			element.addEventListener('click', toggleCountrySlidedown);
		}, this);

		document.querySelectorAll(".localisation__country-select").forEach(function (element) {
			element.value = localisation__countryCodes[this.country];
			element.addEventListener('change', this._onChange_Country_Select.bind(this));
		}, this);

		document.querySelectorAll(".localisation__currency-select").forEach(function (element) {
			element.value = this.currency;
			element.addEventListener('change', this._onChange_Currency_Select.bind(this));
		}, this);

		document.querySelectorAll(".localisation__tax-icon").forEach(function (element) {
			element.addEventListener('click', this._onClick_Tax.bind(this));
		}, this);

		//document.querySelector(".hidden-style__headericons").remove();
	}

	attributeChangedCallback(name, oldValue, newValue) {
		//console.log("-------- attributeChangedCallback (local-icon) --------");
		//console.log("-------- " + name + " changed from '" + oldValue + "' to '" +  newValue + "' --------")		
		if (oldValue != newValue) {
			// case if country changed
			if (name == "country") {
				if (!Object.values(localisation__countryNames).includes(newValue)) {
					if (!Object.values(localisation__countryNames).includes(oldValue)) {
						this.country = oldValue;
						//console.log("-------- early return (local-icon) --------");

					} else {
						this.country = "GB";
					}
				}

				if (Object.keys(localisation__countryTax).includes(this.country)) {
					this.taxRate = localisation__countryTax[this.country];
					this.taxEnabled = true;

					//console.log("-------- early return (local-icon) --------");

				} else {
					this.taxRate = 0;
					this.taxEnabled = false;
					//console.log("-------- early return (local-icon) --------");

				}
			}
			// case if currency changed
			if (name == "currency") {
				if (!Object.keys(localisation__symbols).includes(newValue)) {
					if (!Object.keys(localisation__symbols).includes(oldValue)) {
						this.currency = oldValue;
					} else {
						this.currency = "GBP";
					}
				}
			}

			if (this.country !== null && this.currency !== null && this.taxShown !== null && this.taxEnabled !== null) {
				this.update_Localisation_Values();
				document.querySelectorAll(".localisation__country-icon").forEach(function (element) {
					element.setAttribute('country', this.country);
				}, this);
			}

			if (this.currency) {
				document.querySelectorAll(".localisation__currency-icon").forEach(function (element) {
					element.setAttribute('currency', this.currency);
				}, this);
			}


			//console.log("-------- finished return (local-icon) --------");
		} else {
			//console.log("-------- unchanged return (local-icon) --------");
		}
	}

	update_Localisation_Values() {
		var priceElements = document.getElementsByTagName('price-span');
		for (var element of priceElements) {
			element.priceUpdater();
		}
	}

	set taxEnabled(newValue) {

		this.setAttribute('tax-enabled', newValue === true);

		document.querySelectorAll(".localisation__tax-icon").forEach(function (element) {
			element.setAttribute('tax-enabled', newValue === true);
		});

		if (newValue === true) {
			this._visiblity_tax_enabled('enabled');
		} else {
			this._visiblity_tax_enabled('disabled');
		}

	}
	get taxEnabled() { return this.getAttribute('tax-enabled') == 'true' }

	set country(newValue) {
		this.setAttribute('country', newValue);
		sessionStorage.setItem('localisation-country', newValue);
		document.querySelectorAll(".localisation__country-icon").forEach(function (element) {
			element.setAttribute('country', newValue);
		});
		if (typeof window.shippingCalc === "function") {
			setShippingCountrySelect();
		}

	}
	get country() { return this.getAttribute('country'); }
	set currency(newValue) {
		this.setAttribute('currency', newValue);
		sessionStorage.setItem('localisation-currency', newValue);
		document.querySelectorAll(".localisation__currency-icon").forEach(function (element) {
			element.setAttribute('currency', newValue);
		});
	}
	get currency() { return this.getAttribute('currency'); }
	set taxShown(newValue) {
		//if (newValue != this.taxShown) {
		if (newValue === true) {
			var taxName = "<div>inc</div><div>" + (localisation__taxName[this?.country] ?? "tax") + "</div> ";
			this.taxSpan.innerHTML = taxName;
			this.setAttribute('tax-shown', 'true');
			sessionStorage.setItem('localisation-tax-shown', true);
			document.querySelectorAll(".localisation__tax-icon").forEach(function (element) {
				element.setAttribute('tax-shown', 'true');
				element.innerHTML = taxName;
			});
			this._show_hide_tax_shown('shown')

		} else {
			var taxName = "<div>ex</div><div>" + (localisation__taxName[this?.country] ?? "tax") + "</div> ";
			this.taxSpan.innerHTML = taxName;
			this.setAttribute('tax-shown', 'false');
			sessionStorage.setItem('localisation-tax-shown', false);
			document.querySelectorAll(".localisation__tax-icon").forEach(function (element) {
				element.setAttribute('tax-shown', 'true');
				element.innerHTML = taxName;
			});
			this._show_hide_tax_shown('hidden')
		}
		//}
	}
	get taxShown() { return this.getAttribute('tax-shown') == 'true'; }

	_visiblity_tax_enabled(enabledDisabled) {
		if (enabledDisabled == 'enabled') {
			if (this.taxShown) {
				this._show_hide_tax_shown('shown');
			} else {
				this._show_hide_tax_shown('hidden');
			}
			document.querySelectorAll(".localisation__hide-when-tax-enabled").forEach(function (element) {
				element.classList.add('visibility-hidden');
			});
			document.querySelectorAll(".localisation__hide-when-tax-disabled").forEach(function (element) {
				element.classList.remove('visibility-hidden');
			});
			this._show_hide_tax_shown();
		} else if (enabledDisabled == 'disabled') {
			this._show_hide_tax_shown('hidden');
			document.querySelectorAll(".localisation__hide-when-tax-enabled").forEach(function (element) {
				element.classList.remove('visibility-hidden');
			});
			document.querySelectorAll(".localisation__hide-when-tax-disabled").forEach(function (element) {
				element.classList.add('visibility-hidden');
			});

		}
	}

	_rerun_show_hide_tax_shown() {
		if (this.taxShown) {
			this._show_hide_tax_shown("shown")
		} else {
			this._show_hide_tax_shown("hidden")
		}
	}

	_show_hide_tax_shown(shownHidden) {
		if (shownHidden == 'shown') {
			document.querySelectorAll(".localisation__hide-when-tax-shown").forEach(function (element) {
				element.classList.add('hidden');
			});
			document.querySelectorAll(".localisation__hide-when-no-tax-shown").forEach(function (element) {
				element.classList.remove('hidden');
			});
		} else if (shownHidden == 'hidden') {
			document.querySelectorAll(".localisation__hide-when-tax-shown").forEach(function (element) {
				element.classList.remove('hidden');
			});
			document.querySelectorAll(".localisation__hide-when-no-tax-shown").forEach(function (element) {
				element.classList.add('hidden');
			});
		}
	}

	_onClick_Tax(event) {
		if (this.taxShown) {
			this.taxShown = false;
		} else {
			this.taxShown = true;
		}
	}

	_onChange_Country_Select(event) {
		this.country = localisation__countryNames[event.target.value];
	}

	_onChange_Currency_Select(event) {
		this.currency = event.target.value;
	}

}

customElements.define('localisation-icon', LocalisationIcon);

// UPDATE ALL REFRENCES TO taxEnabled for whether the icon is enabled and UPDATE TO taxShown for whether tax is shown with the prices